<ng-container *ngIf="isDsdContext; else oldLoading">
  <dsd-backdrop *ngIf="isLoading">
    <dsd-container class="loader">
      <dsd-loading size="xs">
        <span *ngIf="type === 'calcul'">{{ 'loader.calcul-en-cours' | translate }}</span>
        <span *ngIf="type === 'page'">{{ 'loader.rendering-page-en-cours' | translate }}</span>
      </dsd-loading>
    </dsd-container>
  </dsd-backdrop>
</ng-container>
<ng-template #oldLoading>
  <div class="loading-full-screen" *ngIf="isLoading" id="loader" [class.higher-z-index]="type === 'calcul'">
    <div class="loading-icon" [ngClass]="{ 'loader-calcul': type === 'calcul' }">
      <mat-spinner strokeWidth="2" diameter="65" id="loading-circle"></mat-spinner>
      <div id="texte-calcul-en-cours" class="texte" *ngIf="type === 'calcul'">
        {{ 'loader.analyse-en-cours' | translate }}
      </div>
    </div>
  </div>
</ng-template>
